import { render } from "./SubjectAddEdit.vue?vue&type=template&id=05ce4148"
import script from "./SubjectAddEdit.vue?vue&type=script&lang=js"
export * from "./SubjectAddEdit.vue?vue&type=script&lang=js"

import "./SubjectAddEdit.vue?vue&type=style&index=0&id=05ce4148&lang=scss"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__